<script>
export default {
    name: 'IconExclamation'
}
</script>
<template>
    <svg
        class="base-icon icon-exclamation"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 56c13.255 0 24-10.745 24-24S45.255 8 32 8 8 18.745 8 32s10.745 24 24 24zm-3.6-16.8h7.2v7.2h-7.2v-7.2zm0-21.6h7.2v16.8h-7.2V17.6z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
